import ChartColors from "../../../../config/ChartColors";
import DoughnutDataset from "../types/DoughnutDataset";

const formatDoughnutDataset = (datasets: DoughnutDataset[]) => {
    const newDataset = {
        labels: [] as string[],
        datasets: [
            {
                data: [] as number[],
                backgroundColor: [] as ChartColors[],
            },
        ],
    };

    datasets.forEach(({ label, data, color }) => {
        newDataset.labels.push(label);
        newDataset.datasets[0].data.push(data);
        newDataset.datasets[0].backgroundColor.push(color);
    });

    return newDataset;
};

export default formatDoughnutDataset;
